import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { I18nProvider } from "@/i18n/I18nContext";
import HomeScreen from "@/screens/Home";
import SongLibrary from "@/screens/SongLibrary";
import Prepare from "@/screens/Prepare";
import Jam from "@/screens/Jam";
import SessionComplete from "@/screens/SessionComplete";
import MyJams from "@/screens/MyJams";
import "@/App.css";

export default function App() {
  return (
    <I18nProvider>
      <AppProvider>
      <BrowserRouter>
        <div data-testid="app-root" className="App">
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/library" element={<SongLibrary />} />
            <Route path="/prepare/:songId" element={<Prepare />} />
            <Route path="/jam/:songId" element={<Jam />} />
            <Route path="/complete" element={<SessionComplete />} />
            <Route path="/my-jams" element={<MyJams />} />
          </Routes>
        </div>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "rgba(18,21,25,0.96)",
              border: "1px solid rgba(245,158,11,0.25)",
              color: "#f8fafc",
            },
          }}
        />
      </BrowserRouter>
    </AppProvider>
    </I18nProvider>
  );
}
